import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { GET_ROLL_NAME_GQL, GET_ROLELIST_GQL } from '@/graphql/queries.gql';

export default {
  namespaced: true,

  state: {
    userTypeName: '',
    usertypeid: '',
    roleList: [],
  },

  mutations: {
    SET_TYPE_NAME(state, payload) {
      state.userTypeName = payload;
    },
    GET_ROLE_LIST(state, payload) {
      state.roleList = payload;
    },
  },

  actions: {
    async getRoleName({ commit }, payload) {
      if (payload.id != null) {
        await apolloClient
          .query({
            query: GET_ROLL_NAME_GQL,
            variables: {
              id: payload.id,
            },
          })
          .then(({ data }) => {
            localStorage.setItem('userRoleName', data.getUserRole.typeName);
            commit('SET_TYPE_NAME', data.getUserRole.typeName);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
 
    getRoleList({ commit }) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_ROLELIST_GQL,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_ROLE_LIST', data.userRoles);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
  },

  getters: {
    userTypeName: state => state.userTypeName,
    roleList: state => state.roleList,
  },
};
